import { readonly, ref } from 'vue';
import { getUniversalStatusApi } from '@/api/superEntry';
import gConf from 'gConf';

// TODO(super-entry): temporary switch shared by the left menu super entry and
// the sidebar entries. When true, the new conversation and scheduled tasks
// entries are hidden and clicking the super entry opens the Vibe Agent page
// instead. The value now comes from GET /api/v1/universal/status
// (`data.available`); while the request is pending or after a failure it falls
// back to the previous domain rule: hidden for overseas (gaia) builds and for
// the domestic yz.cybotstar.cn domain, visible on other domestic domains.
const serverEnv = gConf.serverEnv || '';
const FALLBACK_HIDDEN = !IS_DOMESTIC || serverEnv === 'yz';

const hideTempSidebarEntries = ref(FALLBACK_HIDDEN);
let statusInFlight = null;

// Idempotent loader: concurrent or repeated callers share one request. Only a
// successful response overrides the fallback so a failed status check can never
// flip the entry visibility on its own.
const ensureSuperEntryStatus = () => {
  if (statusInFlight) return statusInFlight;
  statusInFlight = getUniversalStatusApi()
    .then(data => {
      hideTempSidebarEntries.value = data?.available !== true;
    })
    .catch(() => {
      // Network/HTTP failures are already toasted by the global handlers;
      // keep the fallback value.
    })
    .finally(() => {
      statusInFlight = null;
    });
  return statusInFlight;
};

export default function useSuperEntryAvailability() {
  return {
    hideTempSidebarEntries: readonly(hideTempSidebarEntries),
    ensureSuperEntryStatus
  };
}
